import React from 'react'

import { useMessage } from '../../hooks/message'
import { usePostRequest } from '../../hooks/request'
import SalaryForm from './SalaryForm'
import { SALARY_LIST } from '../../urls'

export default function SalaryCreate({ onCancel, categoryList, expenseReport, brandList, category, employeeId }) {
    const products = usePostRequest({ url: SALARY_LIST })
    const [showMessage] = useMessage()

    async function onSubmit(data) {
        const { success, error } = await products.request({ data: { ...data, assigned: employeeId } })
        if (success) {
            expenseReport.request()
            category.request()
            onCancel()
        }
        if (error) showMessage(error?.data?.detail || 'Ошибка', 'is-danger')
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Қўшиш</b>
            </h1>
            <SalaryForm loading={products.loading} categoryList={categoryList} brandList={brandList} onCancel={onCancel}
                onSubmit={onSubmit} />
        </div>
    )
}
